var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ul", { attrs: { id: "list-tasks" } }, [
    _c("li", [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.mobileView,
              expression: "!mobileView"
            }
          ],
          attrs: { id: "oblea" }
        },
        [
          _c("div", { attrs: { id: "seccion1" } }, [
            _c("p", { attrs: { id: "titulo" } }, [
              _vm._v(_vm._s(_vm.numeroPedido))
            ]),
            _vm._v(" "),
            _c("p", { attrs: { id: "fecha" } }, [
              _vm._v(_vm._s(_vm.item.Fecha))
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "label" }, [_vm._v("Items:")]),
            _vm._v(" "),
            _c("span", { staticClass: "value" }, [
              _vm._v(" " + _vm._s(_vm.item.CantidadItems) + " ")
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "label" }, [_vm._v("Precio Total:")]),
            _vm._v(" "),
            _c("span", { staticClass: "value" }, [
              _vm._v("$" + _vm._s(_vm._f("formatMoney")(_vm.item.MontoTotal)))
            ])
          ]),
          _vm._v(" "),
          _c("div", { attrs: { id: "seccion2" } }, [
            _c("div", { attrs: { id: "seccion3" } }, [
              _c("img", {
                class: {
                  iconVerVisible: _vm.item.Estado != 99,
                  iconVerInvisible: _vm.item.Estado == 99
                },
                attrs: { id: "iconVer", src: "/dist/icon-ver.png" },
                on: { click: _vm.btnVerDetalle }
              }),
              _vm._v(" "),
              _c(
                "span",
                {
                  class: {
                    labelR: _vm.item.Estado != 99,
                    labelRInvisible: _vm.item.Estado == 99
                  },
                  staticStyle: {
                    "margin-right": "10px",
                    "margin-left": "10px"
                  },
                  attrs: { id: "labelVer" },
                  on: { click: _vm.btnVerDetalle }
                },
                [_vm._v(" VER")]
              ),
              _vm._v(" "),
              _c("div", {
                staticStyle: { "margin-left": "40px" },
                attrs: { id: "circulo" + _vm.item.Estado }
              }),
              _vm._v(" "),
              _c("span", { staticClass: "labelR" }, [
                _vm._v(" " + _vm._s(_vm.estado(_vm.item.Estado)) + " ")
              ]),
              _vm._v(" "),
              _c("img", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.item.Estado == 99,
                    expression: "item.Estado==99"
                  }
                ],
                staticStyle: {
                  width: "15px",
                  height: "15px",
                  "margin-left": "22px"
                },
                attrs: {
                  id: "btnEliminarBorrador",
                  src: "/dist/icon-delete.png"
                },
                on: { click: _vm.btnEliminarBorrador }
              })
            ]),
            _vm._v(" "),
            _c("div", { attrs: { id: "seccion4" } }, [
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.item.Estado == 99,
                      expression: "item.Estado==99"
                    }
                  ],
                  attrs: { id: "btnIrCarrito" },
                  on: { click: _vm.btnIrCarrito }
                },
                [_vm._v("IR AL CARRITO")]
              )
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.mobileView,
              expression: "mobileView"
            }
          ],
          staticClass: "fv ct",
          staticStyle: { width: "100vw" }
        },
        [
          _c(
            "div",
            {
              staticClass: "fh lc",
              staticStyle: { width: "100%", height: "70px" }
            },
            [
              _c(
                "div",
                {
                  staticClass: "fv lc",
                  staticStyle: { width: "60%", height: "100%" }
                },
                [
                  _c(
                    "div",
                    { staticClass: "fh lc", staticStyle: { width: "100%" } },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "fh lt",
                          staticStyle: {
                            "margin-left": "15px",
                            color: "#5D6770",
                            "font-size": "16px",
                            "font-weight": "600",
                            width: "100px"
                          }
                        },
                        [_vm._v(_vm._s(_vm.numeroPedido))]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "fh lt",
                          staticStyle: {
                            "margin-left": "10px",
                            color: "#5D6770",
                            "font-size": "8px"
                          }
                        },
                        [
                          _vm._v(
                            " (Items: " + _vm._s(_vm.item.CantidadItems) + ") "
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "fv lt",
                      staticStyle: {
                        "margin-left": "15px",
                        color: "#5D6770",
                        "font-size": "8px"
                      }
                    },
                    [_vm._v(_vm._s(_vm.item.Fecha))]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "fh lt",
                      staticStyle: { "margin-left": "15px", width: "100%" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "fh lt",
                          staticStyle: {
                            width: "70%",
                            "margin-top": "10px",
                            color: "#5D6770",
                            "font-size": "10px"
                          }
                        },
                        [
                          _vm._v(" Precio Total:   "),
                          _c("b", [
                            _vm._v(
                              " $" +
                                _vm._s(
                                  _vm._f("formatMoney")(_vm.item.MontoTotal)
                                ) +
                                " "
                            )
                          ])
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "fv lc",
                  staticStyle: { width: "30%", height: "100%" }
                },
                [
                  _c(
                    "div",
                    { staticClass: "fh lc", staticStyle: { width: "100%" } },
                    [
                      _c("div", {
                        staticStyle: { "margin-left": "5px" },
                        attrs: { id: "circulo" + _vm.item.Estado }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "labelR" }, [
                        _vm._v(" " + _vm._s(_vm.estado(_vm.item.Estado)) + " ")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.item.Estado == 99,
                          expression: "item.Estado==99"
                        }
                      ],
                      staticClass: "fh cc",
                      staticStyle: { width: "100%" }
                    },
                    [
                      _c("img", {
                        staticStyle: {
                          width: "20px",
                          height: "20px",
                          "margin-left": "15px",
                          "margin-right": "20px"
                        },
                        attrs: {
                          id: "btnEliminarBorrador",
                          src: "/dist/carrito-gris.svg"
                        },
                        on: { click: _vm.btnIrCarrito }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticStyle: { width: "20px", height: "20px" },
                        attrs: {
                          id: "btnEliminarBorrador",
                          src: "/dist/icon-delete.png"
                        },
                        on: { click: _vm.btnEliminarBorrador }
                      })
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.item.Estado != 99,
                      expression: "item.Estado!=99"
                    }
                  ],
                  staticClass: "fv cc",
                  staticStyle: { width: "10%", height: "100%" }
                },
                [
                  _c("img", {
                    staticStyle: { width: "10px", height: "10px" },
                    attrs: { src: "/dist/icon_right.png" },
                    on: { click: _vm.btnVerDetalle }
                  })
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c("div", {
            staticClass: "fh lt",
            staticStyle: { width: "100%", height: "1px", background: "#dddddd" }
          })
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9092c086", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9092c086","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/estadoPresupuesto/itemEstadoPresupuesto.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-9092c086","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/estadoPresupuesto/itemEstadoPresupuesto.vue
// module chunks = 0